import { Component, OnInit, inject } from '@angular/core';
import { AuthenticationService } from 'app/core/services/authentication.service';
import { ClientsService } from 'app/core/services/clients.service';
import { Client } from 'app/core/models/client.model';
import { UserRoleName } from 'app/core/enums/user-role-name.enum';
import { DecimalPipe } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ClientListComponent } from '../../components/client-list/client-list.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-clients',
    templateUrl: './capture-admin-clients.component.html',
    imports: [RouterLink, RouterLinkActive, ClientListComponent, MatProgressSpinner, DecimalPipe]
})
export class CaptureAdminClientsComponent implements OnInit {
  private clientsService = inject(ClientsService);
  private authService = inject(AuthenticationService);

  clients: Client[] = [];
  loading = true;
  canManageClients = false;
  canManageClientConfigurations = false;

  ngOnInit() {
    this.canManageClients = this.authService.hasPermissionTo(UserRoleName.manageClients);
    this.canManageClientConfigurations = this.authService.hasPermissionTo(UserRoleName.manageClientConfigurations);
    this.loadClients();
  }

  private loadClients() {
    this.loading = true;

    this.clientsService.getList().subscribe(result => {
      this.clients = result.clients;
      this.loading = false;
    });
  }
}
